import { Component, OnInit ,Injector} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../src/environments/environment';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent  extends BaseComponent implements OnInit {
  data: any = {};
  username = "";
  password = "";
  api = '';
  message = "";
  showModal = false
  resetemail = ""
  resetmessageobj:any = {}

  constructor(private http: HttpClient, injector: Injector) {  super(injector)}

  ngOnInit(): void {
    this.api = environment.backendapi;
  }

  async login() {
    this.loader.show();
    const headers: any = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    let body = { username: this.username, password: this.password };
    let url = this.api + "Authenticate/login";
    this.http.post<any>(url, body, headers).subscribe(
      {
        next: (data: any) => {
          this.data = data;
          sessionStorage.setItem('token', data.token);
          sessionStorage.setItem('isLoggedIn', "true");
          sessionStorage.setItem('firstName', data.userInfo.firstName);
          sessionStorage.setItem('lastName', data.userInfo.lastName);
          sessionStorage.setItem('organizationId', data.userInfo.organizationId);
          sessionStorage.setItem('orgName', data.orgName);
          sessionStorage.setItem('userRoles', JSON.stringify(data.userRoles));

          this.loader.hide();
          this.router.navigate(['home']);
        },
        error: (error) => {
          this.loader.hide();
          this.message = "Wrong username or password";
        }
      });
  }
  resetPassword(){
    this.showModal = true
  }
  async submitreset(){
    // if isTest == true  means the email link goes to peter.schmitt.cellpodium.com and uses localhost
    const resp = await this.db.get("authenticate","SetResetTokenAndSendEmail",{ email: this.resetemail,isTest: false})
    this.message = resp.message
    //this.alert.success("Please check your email and follow the link")
    this.showModal = false
  }
}

